import React from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';
import Joi from 'joi-browser';

import { CompanyService } from '../services/Companies';
import { AttachDocuments } from '../services/AttachDocuments';
import { UserProfileService } from '../services/UserProfiles';
import { GreenService } from '../services/GreenFile'; // 労安項目情報API
import { RegionalDevelopmentBureauxService } from '../services/RegionalDevelopmentBureaux'; // 振興局情報API

import { PrimaryCompanyNaviList } from '../components/list/PrimaryCompanyNaviList';
import {
  PrimeCompanyForm,
  PrimeCompanySaftyForm,
} from '../components/forms/PrimeCompany'; // フォーム

import dialogLoader from '../utilities/dialogLoader';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import regex from '../utilities/validateRegex';
import {
  validationByJoi,
  validationByJoi_New,
} from '../utilities/commonValidation';

import ImageUtility from '../utilities/imageUtility';
import { messageUtility } from '../utilities/messageUtility'; // ユーザー情報API
import { companySaftyEditSchema } from '../utilities/validationSchemas/companySaftyEdit';
import {
  // LEGAL_PERSONALITIES, // 法人格
  HEADER_CONSTANTS, // ヘッダータイトル
  maxiileSize, // 画像ファイルサイズ
  DIALOG_STATUS,
  OTHER_SUBSCRIPTION_INSURANCE_STATUSES,
  EXISTANCE_EXCLUSION_FLAG,
  EXCLUDE_KEY_COMPANY_BRANCH_PERMISSIONS,
  EXISTANCE_FLAG,
} from '../utilities/constants';
import { isLoginUserPartner } from '../utilities/roleUtility';
import SessionStorageService from '../../src/services/utilities/SessionStorageService';
import { deleteControlCode } from '../utilities/stringUtil';
import { onceAsyncRequest } from '../utilities/commonUtil';

import ConfirmationSafetyDocItemDialog from '../components/worker/dialog/ConfirmationSafetyDocItemDialog';

import Style from '../styles/componentStyle/worker/insuranceInfo/insuranceInfo.scss';
import { schemaForSafetyDoc } from '../utilities/validationSchemas/primeCompanyEdit';
import {
  createErrorMessageList,
  CONSTRUCTION_INDUSTRY_PERMISSION_FLAG,
  HEALTH_INSURANCE_FLAG,
  PENSION_FLAG,
  EMPLOYMENT_INSURANCE_FLAG,
  PRESENCE,
  EXCLUSION,
  isConstructionIndustryPermissionStatus,
  showPrefectureInput,
  getCompanyBranchPermissionsErrorMsg,
  deleteCompanyBranchPermissionsErrorMsgByIndex,
  showRegionalDevelopmentBureau,
  getParamCommonCompanyBranchPermission,
  getAllCommonCompanyBranchPermissionId,
  cleanupBeforeUpdateUtil,
  validateCompanyBranchForeignerEngagementPeriod,
} from '../utilities/companySafetyUtil';
import {
  attachDocumentDeleteState,
  attachDocumentCompanyUploadState,
  attachDocumentCompanyDownload,
} from '../utilities/attachDocumentUtil';
import { MasterPageHeader } from '../components/PageHeader';
import { CloseEditView } from '../components/CloseEditView';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { convertDate } from '../utilities/validateDateUtil';
import Information from '../components/modals/common/Information';
import { DeleteCompanyLicenseConfirmDialog } from '../components/modals/DeleteCompanyLicenseConfirmDialog';

const defaultRequiredColumn = [
  'name',
  'kana',
  'postal_code',
  'prefectures_code_id',
  'city_name',
  'street_number',
  'tel',
];

/**
 * 会社情報確認 画面
 *  元請用
 * 画面遷移
 *  - 本社管理者でログイン > 会社情報確認 > 編集ボタン
 */
export class PrimeCompanyEdit extends React.Component {
  constructor(props) {
    super(props);
    // IEのみファイルアップロードするとconsoleにTypeMismatchErrorエラーが表示される問題の対策
    window.onunhandledrejection = function(event) {
      event.preventDefault();
    };
    this.state = {
      roleId: localStorage.getItem('role_id'), // ユーザーロール
      userId: localStorage.getItem('user_id'),
      companyId: SessionStorageService.getCompanyId(),
      use_greenfile_flg: '', // 労務安全使用フラグ
      // companyId: this.props.view.state.id, // 元請Id
      partnerCompanyId: '', // 協力会社ID
      // isCommonHojin: false,
      requiredInput: {
        // 必須入力項目
        columns: defaultRequiredColumn, // 必須項目名
        total: 0, // 必須総数
        count: 0, // 入力数
      },
      validate: {
        invalid: false, // 入力内容エラー
        messages: {}, // エラー内容
      },
      image: {
        // アップロード画像
        file: '', // バイナリ
        path: '', // 画像URL
        isSet: false, // 画像セットフラグ
      },

      checkboxList: {
        construct_permit_source_types: {}, // 許可元区分名
        construct_permit_types: {}, // 建設許可区分名
        insurance_statuses: {}, // 健康保険、年金保険、雇用保険の加入状態
        workmans_compensation_insurance_statuses: {}, // 労災保険特別加入状況
        kentaikyo_insurance_statuses: {}, // 建退共制度加入状況
        chutaikyo_insurance_statuses: {}, // 中退共制度加入状況
        other_subscription_insurance_statuses: OTHER_SUBSCRIPTION_INSURANCE_STATUSES, //その他退職金共済制度加入状況
      },

      comboboxList: {
        construct_permit_industry_types: {}, // 許可業種名
        health_insurance_exclusions: {}, // 健康保険_適用除外理由
        health_insurance_types: {}, // 健康保険種類
        pension_insurance_exclusions: {}, // 年金保険適用除外理由
        pension_insurance_types: {}, // 年金保険種類名称
        employment_insurance_exclusions: {}, // 雇用保険適用除外理由
      },

      documentCodes: [],
      bureaux: [], // 振興局（APIから取得）

      formValues: {
        name: '', // 会社名
        kana: '', // 会社名かな
        postal_code: '', // 郵便番号
        prefectures_code_id: '', // 都道府県
        city_name: '', // 市区町村
        street_number: '', // 丁目・番地
        building_name: '', // 建物名・部屋番号
        tel: '', // 電話番号
        fax: '', // FAX
        joining_flag: '', // Buildee利用
        common_partner_company_code: '', // 協力会社コード
      },

      safetyValues: {
        // 代表者情報
        company_detail: {
          delegate_name: '', // 代表者名
          delegate_name_kana: '', // 代表者名フリガナ
          delegate_post: '', // 代表者名役職
          construction_industry_permission_flag: EXISTANCE_FLAG.NOEXIST.VALUE, // 建設業許可有無フラグ
          acceptance_foreign_workers_flag: 0, // 外国人就労者受入有無
        },
        old_company_permission_documents: [],

        // 許可情報
        company_branch_permissions: [],
        company_branch_permission_groups: [],
        // 許可情報削除対象を保持する配列
        delete_company_branch_permission_document_ids: [],
        delete_company_branch_permission_ids: [],
        delete_company_branch_permission_group_ids: [],
        // 保険情報
        company_branch_insurance: {
          health_insurance_flag: '', // 健康保険_加入状況
          ccus_health_insurance_reason_exclusion_code: '', // 社会保険適用外理由コード_健保
          health_insurance_reason_exclusion: '', // 健康保険_適用除外理由
          health_insurance_type_code: '', // 健康保険_健康保険種類コード
          health_insurance_type: '', // 健康保険_健康保険種類
          health_insurance_name_insurer: '', // 健康保険_健康保険者名称
          health_insurance_office_symbol: '', // 健康保険_事業所整理記号
          health_insurance_office_number: '', // 健康保険_事業所整理番号
          pension_flag: '', // 年金保険_加入状況
          ccus_pension_reason_exclusion_code: '', // 社会保険適用外理由コード_年金
          pension_reason_exclusion: '', // 年金保険_適用除外理由
          pension_type_code: '', // 年金保険_年金種類コード
          pension_type: '', // 年金保険_年金保険種類名称
          pension_office_symbol: '', // 年金保険_事業所整理記号
          pension_office_number: '', // 年金保険_事業所番号
          employment_insurance_flag: '', // 雇用保険_加入状況
          ccus_employment_insurance_reason_exclusion_code: '', // 社会保険適用外理由コード_雇用
          employment_insurance_reason_exclusion: '', // 雇用保険_適用除外理由
          employment_insurance_insurance_number: '', // 雇用保険_労働保険番号
          worker_compensation_flag: '', // 労災保険特別加入_加入状況
          worker_compensation_number: '', // 労災保険特別加入_労働保険番号
          worker_compensation_organize_number: '', // 労災保険特別加入_整理番号
          worker_add_on_compensation_flag: '', // 労災保険_労災上乗保険_加入状況
          const_subscription_flag: '0', // 建設業退職金共済制度加入状況
          const_subscription_number: '', // 建設業退職金共済契約者番号
          enterprise_subscription_flag: '0', // 中小企業退職金共済制度_加入状況
          enterprise_subscription_number: '', // 中小企業退職金共済契約者番号
          other_subscription_flag: '0', // その他退職金共済制度加入状況
          other_subscription_name: '', // その他退職金共済制度名称
        },

        // 外国人就労者情報
        company_branch_foreigner: {
          certification_number: '', // 適正監理計画認定番号
          supervisor_worker_id: null, // ワーカーID_受入監理責任者
          supervisor_name: '', // ワーカー名_受入監理責任者
          supervisor_position_name: '', // 役職名_受入監理責任者
          leader_worker_id: null, // ワーカーID_受入監理指導員
          work_place: '', // 外国人就労者_就労場所
          engagement_content: '', // 外国人就労者_従事業務内容
          engagement_start_date: null, // 外国人就労者_従事開始年月日
          engagement_end_date: null, // 外国人就労者_従事終了年月日
        },
      },
      dialogStatus: DIALOG_STATUS.disabled.id,
      confirmationModalSafetyDocItem: {
        // 安全書類項目用バリデート
        errorPropertyList: [],
      },
      clearValuesArr: [],
      initCompanyDocuments: {},
      visibleDialogFlag: false,
      visibleConfirmDeleteDialog: false,
      deleteCompanyBranchPermissionsExistGreenFile: [],
      expirationCompany: {},
    };

    this.initForm = this.initForm.bind(this); // フォーム生成
    this.submit = this.submit.bind(this); // 会社登録
    this.validate = this.validate.bind(this); // バリデーション
    this.imageExists = this.imageExists.bind(this); // 画像判定

    this.targetNumberType = [
      'permitted_source_section',
      'construction_industry_permission_section',
    ];
    this.clearFlagList = [
      'construction_industry_permission_flag',
      'health_insurance_flag',
      'pension_flag',
      'employment_insurance_flag',
    ];

    this.companyBranchInsuranceKeys = {
      health_insurance_flag: 'health_insurance_office_number',
      pension_flag: 'pension_office_number',
      employment_insurance_flag: 'employment_insurance_insurance_number',
    };
    // イベント登録
    this.events = {
      dialog: {
        // ダイアログ
        goBack: this.handleGoBackDialog.bind(this), // 閉じる
      },
      form: {
        // フォーム関連
        setCompany: this.setCompany.bind(this), // 会社情報入力
        validate: this.validate.bind(this), // フォーカスアウト時のバリデーション
        setImage: this.setImage.bind(this), // 画像アップ
        update: this.update.bind(this), // 更新
        deleteImage: this.deleteImage.bind(this), // 画像削除
        setFormValue: this.setFormValue.bind(this), // textareaの値セット
        setCalendar: this.setCalendar.bind(this), // カレンダーの日付セット
        deletePermission: this.deletePermission.bind(this), // 許可情報の削除
        uploadFile: this.uploadFile.bind(this), // ファイル追加予定
        deleteFile: this.deleteFile.bind(this), // ファイル削除予定
        deleteOldCompanyPermissionDocuments: this
          .deleteOldCompanyPermissionDocuments,
        handleDeletePermissionExistGreenFile: this
          .handleDeletePermissionExistGreenFile,
      },
    };

    // 会社情報バリデーションパターン
    this.companySchema = {
      name: Joi.string()
        .required()
        .max(255), // 会社名
      kana: Joi.string()
        .label('hiragana')
        .regex(regex.pattern.hiragana)
        .required()
        .max(512), // 会社名かな
      postal_code: Joi.string()
        .label('zip')
        .regex(regex.pattern.zip)
        .required(), // 郵便番号
      prefectures_code_id: Joi.number().required(), // 都道府県
      city_name: Joi.string()
        .label('city_name')
        // .regex(regex.pattern.must)
        .required()
        .max(512), // 市区町村
      street_number: Joi.string()
        .required()
        .max(512), // 丁目・番地
      building_name: Joi.string()
        .max(512)
        .allow(null, ''), // 建物名・部屋番号等
      tel: Joi.string()
        .label('tel')
        .regex(regex.pattern.tel)
        .required(), // 電話番号
      fax: Joi.string()
        .label('fax')
        .regex(regex.pattern.tel)
        .allow(null, ''), // FAX
      joining_flag: Joi.string().allow(null, ''), // Buildee利用
      common_partner_company_code: Joi.string()
        .max(16)
        .allow(null, ''), // 協力会社コード
    };

    this.saftyEditSchema = companySaftyEditSchema();

    // 戻るダイアログ
    this.GoBack = {
      callback: {
        clear: () => {
          const id = this.props.view.state.id;
          if (id) {
            _masterSlideLoader.show('PrimeCompanyPreview', { state: { id } });
          } else {
            _masterSlideLoader.show('PrimeCompanyPreview', { state: {} });
          }
          dialogLoader.close();
        },
        close: () => {
          dialogLoader.close();
        },
      },
    };

    this.eventCompanyBranchPermissionCommon = {
      handleCompanyBranchPermission: this.handleCompanyBranchPermission,
      handleDeleteCompanyBranchPermission: this
        .handleDeleteCompanyBranchPermission,
      download: this.download,
    };
    this.confirmDeleteDialogFn = null;
    this.isSubmittingFlag = false;
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.state.companyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  componentDidMount() {
    const param = {};
    if (this.state.companyId > 0) {
      param.company_id = this.state.companyId;
    }
    // フォームに値セット
    UserProfileService.show(this.state.userId, param).then(response => {
      if (response.result) {
        const entity = response.data.entities;

        let company, images;
        if (isLoginUserPartner()) {
          const sessionPrimeCompanyId = SessionStorageService.getItem(
            'sessionPartnerCompanyIdOfPrimeCompany'
          );
          if (sessionPrimeCompanyId) {
            company = _.find(response.data.entities.company, company => {
              return String(company.id) === sessionPrimeCompanyId;
            });
            if (company.icon_image) {
              images = `${window.location.origin}/applications/images/company/${
                company.icon_image
              }`;
            }
          }
        } else {
          company = entity.company[0];
          images = entity.company_icon_image_url;
        }

        this.initForm(company, images);
        if (entity.use_greenfile_flg === 1) {
          // this.setState({ use_greenfile_flg: entity.use_greenfile_flg });
          this.getSafety(entity.use_greenfile_flg, company.id);
        }

        const { joining_flag, one_master_flag } = company;
        if (
          joining_flag === 1 &&
          (one_master_flag === null || one_master_flag === 0)
        ) {
          throw new Error(
            'PrimeCompanyEdit.jsx getCompany joining_flag one_master_flag'
          );
          // 元請の処理なので、常に法人のため法人判定が必要ない
          // ということをリファクタリングのために確定するための判定処理
        }
      }
    });
    const params = {
      offset: 0,
      is_limit: 0,
    };
    AttachDocuments.documentCodes(params).then(response => {
      if (!response.result) {
        return;
      }
      const file_typeL = _.map(
        _.uniqBy(
          response.data.entities.document_codes,
          type => type.file_typeL
        ),
        type => type.file_typeL
      );
      this.setState({
        documentCodes: response.data.entities.document_codes,
        safetyValues: {
          ...this.state.safetyValues,
          company_documents: {
            ...this.state.safetyValues.company_documents,
            file_typeL,
          },
        },
      });
    });
    CompanyService.companyDocuments(this.state.companyId, params).then(
      response => {
        if (!response.result) {
          return;
        }
        this.setState({
          companyDocuments: response.data.entities.company_documents,
          initCompanyDocuments: response.data.entities.company_documents,
        });
      }
    );
    this.getExpiration();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevState.companyDocuments, this.state.companyDocuments)) {
      const files = _.map(this.state.companyDocuments, file => {
        if (file.id) {
          return {
            id: file.id,
            file_typeL: file.file_typeL,
            file_typeS: file.file_typeS,
            file_name: file.file_name,
          };
        } else {
          return {
            temp_file_key: file.temp_file_key,
            file_typeL: file.file_typeL,
            file_typeS: file.file_typeS,
            file_name: file.file_name,
          };
        }
      });
      this.setState({
        safetyValues: {
          ...this.state.safetyValues,
          company_documents: {
            ...this.state.safetyValues.company_documents,
            files,
          },
        },
      });
    }
  }

  uploadFile = async (file, typeL, typeS) => {
    attachDocumentCompanyUploadState(
      this.state.companyDocuments,
      documents => {
        this.setState({ companyDocuments: documents }, () =>
          this.validateAllAttachFiles()
        );
      },
      this.state.companyId,
      file,
      typeL,
      typeS
    );
  };

  deleteFile = file => {
    attachDocumentDeleteState(
      this.state.companyDocuments,
      documents => {
        this.setState({ companyDocuments: documents }, () =>
          this.validateAllAttachFiles()
        );
      },
      file
    );
  };

  validateAllAttachFiles = () => {
    let messages = _.cloneDeep(this.state.validate.messages);
    let invalid = !this.filesCheck();
    if (!_.isEmpty(messages)) {
      invalid = true;
    }
    this.setState(
      {
        validate: {
          messages,
          invalid,
        },
      },
      this.checkRequired
    );
  };

  /**
   * フォーム生成
   * @param company {object} 会社情報
   * @param images
   */
  initForm(company, images) {
    const formValues = _.cloneDeep(this.state.formValues);
    const image = _.cloneDeep(this.state.image);
    const requiredInput = { ...this.state.requiredInput };

    // 会社情報
    _.each(company, (company_data, index) => {
      if (_.has(formValues, index)) {
        formValues[index] = !_.isNull(company_data) ? `${company_data}` : '';
      }
    });

    image.path = images;

    this.setState(
      {
        image,
        formValues,
        partnerCompanyId: company.id,
        requiredInput,
      },
      () => {
        this.checkRequired();
      }
    );
  }

  getSafety(use_greenfile_flg, company_id) {
    // フォームに値セット
    GreenService.list(company_id).then(response => {
      if (!response.result) {
        return;
      }
      const safetyValues = _.cloneDeep(this.state.safetyValues);
      const data = response.data.entities;
      _.map(data, (company_data, company_key) => {
        if (!_.includes(EXCLUDE_KEY_COMPANY_BRANCH_PERMISSIONS, company_key)) {
          _.map(company_data, (data, key) => {
            safetyValues[company_key][key] = data;
          });
        }
      });
      safetyValues.old_company_permission_documents = _.get(
        data,
        'old_company_permission_documents'
      );
      safetyValues.company_branch_permissions = _.get(
        data,
        'common_company_branch_permission_groups'
      );
      // 保険情報が初期取得の時点で状況が「無」「適用除外」の場合、項目の値を消す
      // TODO: 可能ならfindStatusおよびclearStateByConditionで処理する
      _.map(data.company_branch_insurance, (data, key) => {
        if (key === 'pension_flag' && data !== '1') {
          safetyValues['company_branch_insurance']['pension_office_number'] =
            '';
        }
        if (key === 'employment_insurance_flag' && data !== '1') {
          safetyValues['company_branch_insurance'][
            'employment_insurance_insurance_number'
          ] = '';
        }
        // 建退共、中退共、その他退職金共済制度の加入フラグはデフォルトで「無」のため「有」以外（nullや空文字含む）の場合には'0'を設定する
        if (key === 'const_subscription_flag' && data !== '1') {
          safetyValues['company_branch_insurance']['const_subscription_flag'] =
            '0';
        }
        if (key === 'const_subscription_number' && data === null) {
          safetyValues['company_branch_insurance'][
            'const_subscription_number'
          ] = '';
        }
        if (key === 'enterprise_subscription_flag' && data !== '1') {
          safetyValues['company_branch_insurance'][
            'enterprise_subscription_flag'
          ] = '0';
        }
        if (key === 'enterprise_subscription_number' && data === null) {
          safetyValues['company_branch_insurance'][
            'enterprise_subscription_number'
          ] = '';
        }
        if (key === 'other_subscription_flag' && data !== '1') {
          safetyValues['company_branch_insurance']['other_subscription_flag'] =
            '0';
        }
        if (key === 'other_subscription_name' && data === null) {
          safetyValues['company_branch_insurance']['other_subscription_name'] =
            '';
        }
      });

      this.setState(
        {
          safetyValues,
          use_greenfile_flg,
        },
        async () => {
          await this.resetRequiredColumnWhenConstructionIndustryPermissionStatus();
          await this.validate('company_detail');
          await this.validate('company_branch_foreigner');
        }
      );
    });
    // 振興局情報APIから取得
    RegionalDevelopmentBureauxService.list().then(response => {
      if (!response.result) {
        return;
      }
      const bureaux = response.data.entities.regional_development_bureaux;
      this.setState({ bureaux });
    });

    // checkbox,combobox内に表示する情報取得
    GreenService.ccus_list().then(response => {
      if (!response.result) {
        return;
      }
      let checkboxList = { ...this.state.checkboxList };
      let comboboxList = { ...this.state.comboboxList };
      const data = response.data.entities;
      // 取得したデータを格納
      checkboxList = this.dataSet(data, checkboxList);
      comboboxList = this.dataSet(data, comboboxList);
      this.setState({
        checkboxList,
        comboboxList,
      });
    });
  }

  /**
   * 取得したデータを格納
   * @param data {object} 会社情報
   */
  dataSet(data, formData) {
    _.map(data, (value, key) => {
      if (_.has(formData, key)) {
        formData[key] = _.defaultTo(value, '');
      }
    });
    return formData;
  }

  /**
   * 戻るダイアログ表示
   */
  handleGoBackDialog = () => {
    dialogLoader.show(CloseEditView, this.GoBack);
  };

  /**
   * 会社情報入力
   */
  setCompany = (e, resultValue) => {
    const { formValues } = _.cloneDeep(this.state);
    let name, value;
    if (!_.isEmpty(e.target, 'name')) {
      name = e.target.name;
    } else {
      name = e;
    }
    if (!_.isUndefined(e.target)) {
      value = deleteControlCode(e.target.value);
    } else {
      value = resultValue;
    }
    formValues[name] = value;
    this.setState({ formValues }, () => {
      name === 'prefectures_code_id' && this.validate(name);
    });
  };

  /**
   * 画像アップロード
   */
  setImage = e => {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }
    const createObjectURL =
      (window.URL || window.webkitURL).createObjectURL ||
      window.createObjectURL;
    const validate = _.cloneDeep(this.state.validate);
    const image = _.cloneDeep(this.state.image);
    if (files[0].size > maxiileSize) {
      validate.messages.image = messageUtility.getMessage('E-000-011');
      image.isSet = false;
      image.path = '';
      image.file = '';
    } else {
      const url = createObjectURL(files[0]);
      this.imageExists(url, e.target, async (loaded, target) => {
        const type = await ImageUtility.fileTypeCheck(target.files[0]);
        if (loaded && type) {
          image.path = url;
          image.file = target;
          image.isSet = true;
          delete validate.messages.image;
        } else {
          validate.messages.image = messageUtility.getMessage('E-000-012');
          image.isSet = false;
          image.path = '';
          image.file = '';
        }
        this.setState({
          validate,
          image,
        });
      });
      return;
    }
    this.setState({
      validate,
      image,
    });
  };

  /**
   * 画像判定
   * @param url {string}
   * @param target
   * @param callback
   */
  imageExists(url, target, callback) {
    const img = new Image();
    img.src = url;
    img.onload = () => {
      callback(true, target);
    };
    img.onerror = () => {
      callback(false, target);
    };
  }

  /**
   * 画像削除
   */
  deleteImage = () => {
    const image = _.cloneDeep(this.state.image);
    image.path = '';
    image.file = '';
    image.isSet = true;
    this.setState({
      image,
    });
    // onChangeイベントを感知
    document.getElementById('file-company-branch-image').value = '';
  };

  getClearList = (targetName, targetValue, list) => {
    list = _.filter(list, obj => {
      return obj.targetName !== targetName;
    });
    list.push({
      targetName,
      targetValue,
    });
    return list;
  };

  /**
   * 入力
   * @param name {string} テーブル名
   * @param e {events} イベント
   */
  setFormValue = (name, e, index) => {
    const safetyValues = { ...this.state.safetyValues };
    const targetName = e.target.name;
    let targetValue = deleteControlCode(e.target.value);
    _.map(this.targetNumberType, targetNumberName => {
      if (targetNumberName === targetName) {
        targetValue = Number(e.target.value);
      }
    });

    if (index >= 0) {
      safetyValues[name][index][targetName] = targetValue;
    } else {
      safetyValues[name][targetName] = targetValue;
    }
    // 許可業種コード挿入処理
    if (targetName === 'authorized_industry_names') {
      const construct_permit_industry_types = this.state.comboboxList
        .construct_permit_industry_types;
      _.map(construct_permit_industry_types, array => {
        if (array['construct_permit_industry_type_name'] === targetValue) {
          safetyValues[name][index]['authorized_industry_codes'] =
            array['construct_permit_industry_type_code'];
        }
      });
    }
    this.setState({ safetyValues }, () => {
      if (targetName === 'construction_industry_permission_flag') {
        this.resetRequiredColumnWhenConstructionIndustryPermissionStatus();
      }
      // 健康保険加入状況が変更された場合
      if (targetName === 'health_insurance_reason_exclusion') {
        if (
          safetyValues.company_branch_insurance
            .health_insurance_reason_exclusion === 'けんぽ適用除外承認済'
        ) {
          this.setState({
            safetyValues: {
              ...safetyValues,
              company_branch_insurance: {
                ...safetyValues.company_branch_insurance,
                health_insurance_type: '国民健康保険組合',
              },
            },
          });
        }
      }

      if (this.clearFlagList.includes(targetName)) {
        const clearArrs = this.getClearList(
          targetName,
          targetValue,
          this.state.clearValuesArr
        );
        this.setState({ clearValuesArr: clearArrs }, () => {
          targetName === 'construction_industry_permission_flag'
            ? this.validate('company_branch_permissions', targetName, index)
            : this.validate('company_branch_insurance');
        });
      } else {
        this.validate(name, targetName, index);
      }
    });
  };

  /**
   * calendarの値をセット
   * @param name {string} テーブル名
   * @param column {string} カラム名
   * @param date {date} 日付
   */
  setCalendar = (name, column, date, index) => {
    const safetyValues = { ...this.state.safetyValues };
    if (index >= 0) {
      safetyValues[name][index][column] = date;
    } else {
      safetyValues[name][column] = date;
    }

    this.setState({ safetyValues });
  };

  /**
   * 許可情報の削除
   * @param index {int} 許可情報のdeleteするindex
   * @param id
   */
  deletePermission = (index, id) => {
    const { safetyValues, validate } = _.cloneDeep(this.state);
    const { messages: prevMessages } = validate;
    delete safetyValues.company_branch_permissions.splice(index, 1);
    safetyValues.delete_company_branch_permission_ids.push(id);

    let messages = prevMessages;
    const companyBranchPermissionsErrorMsg =
      prevMessages['company_branch_permissions'];
    if (companyBranchPermissionsErrorMsg !== undefined) {
      let newCompanyBranchPermissionsErrorMsg = deleteCompanyBranchPermissionsErrorMsgByIndex(
        companyBranchPermissionsErrorMsg,
        index
      );
      newCompanyBranchPermissionsErrorMsg = newCompanyBranchPermissionsErrorMsg.filter(
        v => v
      );
      if (newCompanyBranchPermissionsErrorMsg.length > 0) {
        messages[
          'company_branch_permissions'
        ] = deleteCompanyBranchPermissionsErrorMsgByIndex(
          companyBranchPermissionsErrorMsg,
          index
        );
      } else {
        // company_branch_permissions配下にエラーがないためキー毎削除する
        delete messages['company_branch_permissions'];
      }
    }

    this.setState({
      safetyValues,
      validate: {
        ...this.state.validate,
        invalid: !_.isEmpty(messages),
        messages,
      },
    });
  };

  changeSchema() {
    // 会社情報バリデーションパターン
    const companySchema = _.cloneDeep(this.companySchema);
    return companySchema;
  }

  // 添付ファイルのサイズ・タイプ・ファイル名が存在するかをチェック
  filesCheck = () => {
    let files = _.cloneDeep(this.state.companyDocuments);
    return !_.some(files, file => file.invalidSize || file.invalidType || file.invalidName);
  };

  /**
   * 社会保険の加入状況やその他の条件に応じてバリデーションメッセージから不要な項目を削除する
   * @param {object} errorMessages: バリデーションメッセージ
   */
  filterErrorMessage = errorMessages => {
    // clearValuesArrに記載された不要な項目について削除する
    _.each(this.state.clearValuesArr, values => {
      if (values.targetName === 'health_insurance_flag') {
        // 健康保険加入状況の場合
        // 加入状況が無の場合、バリデーションエラーメッセージがあっても削除する
        if (values.targetValue === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID) {
          errorMessages.company_branch_insurance &&
            delete errorMessages.company_branch_insurance[
              this.companyBranchInsuranceKeys[values.targetName]
            ];
        }
        // 適用除外かつ5人未満個人事業所かつ国民健康保険の場合にメッセージを削除する
        if (
          values.targetValue === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
          this.state.safetyValues.company_branch_insurance
            .health_insurance_reason_exclusion === '５人未満個人事業所' &&
          this.state.safetyValues.company_branch_insurance
            .health_insurance_type === '国民健康保険'
        ) {
          errorMessages.company_branch_insurance &&
            delete errorMessages.company_branch_insurance[
              this.companyBranchInsuranceKeys[values.targetName]
            ];
        }
      } else {
        if (values.targetValue !== EXISTANCE_EXCLUSION_FLAG.EXIST.ID) {
          if (values.targetName === 'construction_industry_permission_flag') {
            errorMessages = _.omit(errorMessages, [
              'company_branch_permissions',
            ]);
          } else {
            errorMessages.company_branch_insurance &&
              delete errorMessages.company_branch_insurance[
                this.companyBranchInsuranceKeys[values.targetName]
              ];
          }
        }
      }
    });
    if (_.isEmpty(errorMessages.company_branch_insurance)) {
      errorMessages = _.omit(errorMessages, ['company_branch_insurance']);
    }
    return errorMessages;
  };

  /**
   * 入力値の有効判定
   * @return bool
   */
  validate = (keyName, targetName = '', index = null) => {
    // console.log('PrimeCompanyEdit.jsx validate', keyName, this.state);
    if (
      ![
        'name',
        'kana',
        // 'juridical_personality_code',
        'postal_code',
        'prefectures_code_id',
        'city_name',
        'street_number',
        'building_name',
        'tel',
        'fax',
        'common_partner_company_code',
        'company_detail',
        'company_branch_permissions',
        'company_branch_insurance',
        'company_branch_foreigner',
      ].includes(keyName)
    ) {
      throw new Error('PrimeCompanyEdit.jsx validate');
    }

    let errorMessages = _.cloneDeep(this.state.validate.messages);

    if (_.has(this.state.formValues, keyName)) {
      const result = validationByJoi(
        Joi.object().keys(
          _.pick(this.changeSchema(this.state.formValues), keyName)
        ),
        {
          [keyName]: this.state.formValues[keyName],
        }
      );
      if (!result.status) {
        // 失敗

        errorMessages[keyName] = result.messages[keyName];
      } else {
        // 成功
        errorMessages = _.omit(errorMessages, keyName);
      }
    } else if (_.has(this.state.safetyValues, keyName)) {
      errorMessages = this.validateSafetyValues(keyName, targetName, index);
    } else {
      throw new Error(`PrimeCompanyEdit.jsx validateskeyName`);
    }

    errorMessages = this.filterErrorMessage(errorMessages);
    //更新ボタン状態
    let invalid;
    if (!this.filesCheck()) {
      invalid = true;
    } else {
      invalid = false;
    }
    if (!this.handleValidateCompanyBranchPermission()) {
      invalid = true;
      errorMessages.common_company_branch_permission_groups = {};
    } else {
      errorMessages = _.omit(
        errorMessages,
        'common_company_branch_permission_groups'
      );
    }

    this.setState(
      {
        validate: {
          invalid,
          messages: errorMessages,
        },
        triggerValidate: !this.state.triggerValidate,
      },
      () => {
        this.checkRequired();
      }
    );
  };

  validateSafetyValues = (keyName, targetName, index) => {
    let errorMessages = _.cloneDeep(this.state.validate.messages);
    if (!errorMessages) {
      errorMessages = {};
    }
    const schema = companySaftyEditSchema();

    // スキーマを元にバリデーションしてる
    const result = validationByJoi_New(schema, {
      [keyName]: this.state.safetyValues[keyName],
    });

    if (keyName === 'company_branch_foreigner') {
      //Validate companyBranchForeigner end_date is before start_date
      if (
        !validateCompanyBranchForeignerEngagementPeriod(
          result.messages.company_branch_foreigner,
          this.state.safetyValues.company_branch_foreigner
        )
      ) {
        result.messages.company_branch_foreigner = {
          ...result.messages.company_branch_foreigner,
          engagement_start_date: messageUtility.getMessage('E-000-080'),
          engagement_end_date: messageUtility.getMessage('E-000-081'),
        };
        result.status = false;
      }
    }

    // バリデーション失敗時
    if (!result.status) {
      /**
       * company_branch_permissionsは各indexではなく全てのindex(複数の灰色部分全体)で
       * バリデーションされる。
       * そのため、対象にエラーがなくても他indexにエラーがあるとバリデーション失敗時のルートになる
       */
      if (keyName === 'company_branch_permissions') {
        const companyBranchPermissionResult = result.messages[keyName];
        if (targetName === 'construction_industry_permission_flag') {
          errorMessages[
            'company_branch_permissions'
          ] = getCompanyBranchPermissionsErrorMsg(
            errorMessages['company_branch_permissions'],
            targetName,
            index,
            companyBranchPermissionResult
          );
        } else {
          if (companyBranchPermissionResult[index]) {
            errorMessages[
              'company_branch_permissions'
            ] = getCompanyBranchPermissionsErrorMsg(
              errorMessages['company_branch_permissions'],
              targetName,
              index,
              companyBranchPermissionResult
            );
          } else {
            if (_.has(errorMessages, `company_branch_permissions[${index}]`)) {
              // company_branch_permissionsが[undifined]という状況の対策。[undefined, {}]は正常
              if (errorMessages['company_branch_permissions'].length === 1) {
                errorMessages['company_branch_permissions'] = errorMessages[
                  'company_branch_permissions'
                ].filter((item, itemIndex) => itemIndex !== index);
              } else {
                errorMessages[
                  'company_branch_permissions'
                ] = getCompanyBranchPermissionsErrorMsg(
                  errorMessages['company_branch_permissions'],
                  targetName,
                  index,
                  companyBranchPermissionResult
                );
              }
            }
          }
          if (
            _.has(errorMessages, `company_branch_permissions`) &&
            errorMessages['company_branch_permissions'].length === 0
          ) {
            delete errorMessages['company_branch_permissions'];
          }
        }
      }
      // 保険情報とか他の労務安全
      else {
        // 失敗
        errorMessages[keyName] = result.messages[keyName];
      }
    } else {
      // 成功時にエラーメッセージを消す
      if (_.has(errorMessages, `${keyName}`)) {
        errorMessages = _.omit(errorMessages, keyName);
      }
    }
    return errorMessages;
  };

  validateAll() {
    let errorMessages = _.cloneDeep(this.state.validate.messages);
    const result = validationByJoi(
      Joi.object().keys(this.changeSchema(this.state.formValues)),
      this.state.formValues
    );
    if (!result.status) {
      // 失敗
      _.each(result.messages, (message, key) => {
        errorMessages[key] = message;
      });
    } else {
      // 成功
      errorMessages = {};
    }

    const safetyResult = validationByJoi_New(
      this.saftyEditSchema,
      this.state.safetyValues
    );
    _.each(safetyResult.messages, (type, key) => {
      errorMessages =
        key === 'company_branch_permissions'
          ? {
              ...errorMessages,
              company_branch_permissions:
                safetyResult.messages.company_branch_permissions,
            }
          : {
              ...errorMessages,
              [key]: { ...type },
            };
    });

    //Validate companyBranchForeigner end_date is before start_date
    if (
      !validateCompanyBranchForeignerEngagementPeriod(
        errorMessages.company_branch_foreigner,
        this.state.safetyValues.company_branch_foreigner
      )
    ) {
      errorMessages.company_branch_foreigner = {
        ...errorMessages.company_branch_foreigner,
        engagement_start_date: messageUtility.getMessage('E-000-080'),
        engagement_end_date: messageUtility.getMessage('E-000-081'),
      };
    }

    errorMessages = this.filterErrorMessage(errorMessages);
    //更新ボタン状態
    let invalid;
    if (!this.filesCheck()) {
      invalid = true;
    } else {
      invalid = false;
    }

    if (Object.keys(errorMessages).length > 0) {
      invalid = true;
    }
    if (!this.handleValidateCompanyBranchPermission()) {
      invalid = true;
      errorMessages.common_company_branch_permission_groups = {};
    } else {
      errorMessages = _.omit(
        errorMessages,
        'common_company_branch_permission_groups'
      );
    }
    this.setState(
      {
        validate: {
          invalid,
          messages: errorMessages,
        },
        triggerValidate: !this.state.triggerValidate,
      },
      () => {
        this.checkRequired();
      }
    );
    return invalid;
  }

  /**
   * 必須入力状況チェック
   */
  checkRequired = () => {
    const { formValues, validate, safetyValues } = _.cloneDeep(this.state);

    const { company_detail } = safetyValues;
    // 必須チェック
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    let cnt = 0;
    // 会社情報
    _.each(requiredInput.columns, column => {
      if (
        formValues[column] &&
        (!_.has(validate.messages, column) || !validate.messages[column])
      ) {
        cnt++;
      }
    });

    if (this.isUseSafety()) {
      if (
        this.handleValidateCompanyBranchPermission() &&
        isConstructionIndustryPermissionStatus(
          company_detail.construction_industry_permission_flag
        )
      ) {
        cnt++;
      }
      if (
        String(
          _.get(requiredInput.columns, 'construction_industry_permission_flag')
        )
      ) {
        cnt++;
      }

      requiredInput.count = cnt;
      requiredInput.total = _.size(requiredInput.columns);
      this.setState({
        requiredInput,
      });
    }
  };

  /**
   * 更新
   */
  update = () => {
    // 送信前に確認する
    // エラーがなければ、更新処理へ
    const result = this.validateAll();
    if (result) {
      return;
    }

    const safetyValidateResult = this.safetyDocItemValidate();
    if (safetyValidateResult.status === false) {
      this.setSafetyDocErrorMessages(safetyValidateResult);
      this.onOpenSafetyDocItemErrorDialog();
    } else {
      this.submit();
    }
  };

  cleanupSafetyValuesBeforeUpdate = safetyValues => {
    const newSafetyValues = _.cloneDeep(safetyValues);

    const {
      health_insurance_flag,
      health_insurance_reason_exclusion,
      health_insurance_type,
    } = newSafetyValues.company_branch_insurance;

    // 適用除外理由が５人未満個人事業所かつ保険種類が国民健康保険の時
    if (
      health_insurance_flag === EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
      health_insurance_reason_exclusion === '５人未満個人事業所' &&
      health_insurance_type === '国民健康保険'
    ) {
      newSafetyValues.company_branch_insurance.health_insurance_name_insurer =
        '';
      newSafetyValues.company_branch_insurance.health_insurance_office_symbol =
        '';
      newSafetyValues.company_branch_insurance.health_insurance_office_number =
        '';
    }

    newSafetyValues.company_branch_insurance = cleanupBeforeUpdateUtil.cleanupWorkerAddOnCompensationValues(
      newSafetyValues.company_branch_insurance,
      false
    );

    return newSafetyValues;
  };

  getDeletePermissionExistGreenFile = async idsToDelete => {
    const response = await GreenService.getCompanyBranchPermissionIdsUsedGreenFile(
      this.state.partnerCompanyId,
      {
        company_branch_permission_ids: idsToDelete,
        is_prime_contractor: true,
      }
    );
    return {
      isSuccess: response.result,
      companyBranchPermissions: _.get(
        response,
        'data.entities.company_branch_permissions'
      ),
    };
  };

  handleDeletePermissionExistGreenFile = async (idsToDelete, callback) => {
    if (this.isSubmittingFlag) {
      return;
    }
    if (!this.isUseSafety() || _.isEmpty(idsToDelete)) {
      return _.isFunction(callback) && callback();
    }
    this.isSubmittingFlag = true;
    const {
      isSuccess,
      companyBranchPermissions: companyBranchPermissionsExistGreenFile,
    } = await this.getDeletePermissionExistGreenFile(idsToDelete);
    this.isSubmittingFlag = false;
    if (!isSuccess) {
      this.showErrorDialog();
      return;
    }
    if (_.isEmpty(companyBranchPermissionsExistGreenFile)) {
      return _.isFunction(callback) && callback();
    }
    this.confirmDeleteDialogFn = () => {
      this.setState(
        {
          visibleConfirmDeleteDialog: false,
        },
        callback
      );
    };
    this.setState({
      visibleConfirmDeleteDialog: true,
      deleteCompanyBranchPermissionsExistGreenFile: companyBranchPermissionsExistGreenFile,
    });
  };

  /**
   * 本社管理者(等)
   * 「会社情報確認」画面「本社情報」
   * 更新
   */
  submit = onceAsyncRequest(async () => {
    let newSafetyValues = this.getStateWithConvertedDate();
    _.each(this.state.clearValuesArr, values => {
      newSafetyValues = this.clearStateByCondition(
        values.targetName,
        values.targetValue,
        newSafetyValues
      );
    });
    newSafetyValues = this.cleanupSafetyValuesBeforeUpdate(newSafetyValues);
    newSafetyValues.company_branch_permissions = this.setEmptyRegionalDevelopmentBureauIdToNull(
      newSafetyValues.company_branch_permissions
    );
    let values = _.cloneDeep(this.state.formValues);

    newSafetyValues.delete_company_branch_permission_group_ids = getAllCommonCompanyBranchPermissionId(
      newSafetyValues,
      newSafetyValues.delete_company_branch_permission_group_ids
    );
    if (
      isConstructionIndustryPermissionStatus(
        newSafetyValues.company_detail.construction_industry_permission_flag
      )
    ) {
      newSafetyValues.company_branch_permission_groups = [
        ...(_.get(newSafetyValues, 'company_branch_permission_groups') || []),
        ...getParamCommonCompanyBranchPermission(newSafetyValues),
      ];
    }
    newSafetyValues.company_branch_permission_groups = _.map(
      newSafetyValues.company_branch_permission_groups,
      item => _.omit(item, ['company_branch_permissions'])
    );

    newSafetyValues = this.cleanupFormValuesBeforeUpdate(newSafetyValues);
    // 画像セット
    if (this.state.image.isSet) {
      //values = _.assign(values, { icon_image: this.state.image.file });
      values = _.assign(values, { image: this.state.image.file });
    }
    await this.callApiSubmit(values, newSafetyValues);
  });

  callApiSubmit = async (values, newSafetyValues) => {
    const response = await CompanyService.editCompany(
      this.state.partnerCompanyId,
      values
    );

    if (!response.result) {
      return this.showErrorDialog();
    }
    const id = this.props.view.state.id;
    if (this.isUseSafety()) {
      await this.safetyRegister(id, newSafetyValues);
    } else {
      dialogLoader.show(FormInformationDialog, {
        title: '会社情報 本社情報更新',
        message: '会社情報 本社情報の更新が完了しました。',
        onClose: () => {
          dialogLoader.close();
          _masterSlideLoader.show('PrimeCompanyPreview', {
            state: { id },
          });
        },
      });
    }
  };

  getStateWithConvertedDate = () => {
    const safetyValues = _.cloneDeep(this.state.safetyValues);
    safetyValues.company_branch_foreigner.engagement_start_date = convertDate(
      safetyValues.company_branch_foreigner.engagement_start_date
    );
    safetyValues.company_branch_foreigner.engagement_end_date = convertDate(
      safetyValues.company_branch_foreigner.engagement_end_date
    );
    _.each(safetyValues.company_branch_permissions, (item, index) => {
      safetyValues.company_branch_permissions[index].license_date = convertDate(
        item.license_date
      );
      safetyValues.company_branch_permissions[
        index
      ].license_update_date = convertDate(item.license_update_date);
    });
    return safetyValues;
  };

  /**
   * 本社管理者(等)
   * 「会社情報確認」画面「本社情報」
   * 労務安全項目登録
   * 更新
   */
  safetyRegister = async (id, param) => {
    // console.log('PrimeCompanyEdit.jsx safetyRegister param', param);
    await GreenService.update(this.state.partnerCompanyId, param).then(
      response => {
        if (!response.result) {
          const params = {
            offset: 0,
            is_limit: 0,
          };
          CompanyService.companyDocuments(this.state.companyId, params).then(
            response => {
              if (!response.result) {
                return this.showUpdateErrorDialog();
              }
              if (
                JSON.stringify(response.data.entities.company_documents) !==
                JSON.stringify(this.state.initCompanyDocuments)
              ) {
                dialogLoader.show(FormInformationDialog, {
                  title: 'エラーが発生しました',
                  message:
                    '編集中に別のユーザーが更新を行っている可能性があります。\n最新の内容をご確認のうえ、必要であれば再度編集を行ってください。',
                  buttonText: '編集画面を閉じる',
                  onClose: () => {
                    dialogLoader.close();
                    _masterSlideLoader.show('PrimeCompanyPreview', {
                      state: { id },
                    });
                  },
                });
              } else {
                this.showUpdateErrorDialog();
              }
            }
          );
        } else {
          dialogLoader.show(FormInformationDialog, {
            title: '会社情報 本社情報更新',
            message: '会社情報 本社情報の更新が完了しました。',
            onClose: () => {
              dialogLoader.close();
              _masterSlideLoader.show('PrimeCompanyPreview', {
                state: { id },
              });
            },
          });
        }
      }
    );
  };

  // checboxListで選択中のオブジェクトを返却する
  findStatus = targetValue => {
    // checkboxListはAPIから返却されるデータのため読み込むまで空
    if (!_.isEmpty(this.state.checkboxList.insurance_statuses)) {
      return this.state.checkboxList.insurance_statuses.find(
        item => item.value === targetValue
      );
    }
    return null;
  };

  /**
   * 各種保険加入状況によりstateの一部をリセットする
   */
  clearStateByCondition = (name, value, formValues) => {
    const selectedInsuranceStatus = this.findStatus(value);
    let newFormValues = { ...formValues };
    switch (name) {
      case HEALTH_INSURANCE_FLAG:
        newFormValues = this.clearHealthInsuranceState(
          selectedInsuranceStatus,
          formValues
        );
        break;
      case PENSION_FLAG:
        newFormValues = this.clearPensionInsuranceState(
          selectedInsuranceStatus,
          formValues
        );
        break;
      case EMPLOYMENT_INSURANCE_FLAG:
        newFormValues = this.clearEmploymentInsuranceState(
          selectedInsuranceStatus,
          formValues
        );
        break;
      case CONSTRUCTION_INDUSTRY_PERMISSION_FLAG:
        newFormValues = this.clearConstructionIndustryPermissionState(
          formValues
        );
        break;
      default:
        break;
    }
    return newFormValues;
  };

  // 許可情報
  clearConstructionIndustryPermissionState = formValues => {
    const constructionIndustryPermissionStatus = isConstructionIndustryPermissionStatus(
      formValues.company_detail.construction_industry_permission_flag
    );
    if (!constructionIndustryPermissionStatus) {
      const newConstructionIndustryPermissionState = formValues.company_branch_permissions.map(
        companyBranchPermission => {
          return {
            id: companyBranchPermission.id,
            permitted_source_section: null, // 許可元区分名
            prefectures_code_id: null, // 許可都道府県ID
            regional_development_bureau_id: null, // 振興局ID
            construction_industry_permission_section: null, // 建設許可区分名
            authorized_industry_codes: '', // 許可業種コード
            authorized_industry_names: '', // 許可業種名
            permission_number_l: '', // 許可番号 年度
            permission_number_r: '', // 許可番号 固有番号
            license_date: null, // 許可年月日
            license_update_date: null, // 許可更新年月日
          };
        }
      );
      formValues = {
        ...formValues,
        company_branch_permissions: newConstructionIndustryPermissionState,
      };
    }
    return formValues;
  };

  /**
   * 健康保険加入状況（有、無、適用除外）により不必要な入力値をクリアする
   */
  clearHealthInsuranceState = (selectedInsuranceStatus, formValues) => {
    switch (selectedInsuranceStatus.key) {
      case EXCLUSION:
        break;
      case PRESENCE:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            health_insurance_reason_exclusion: '',
          },
        };
        break;
      default:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            health_insurance_type: '',
            health_insurance_name_insurer: '',
            health_insurance_office_symbol: '',
            health_insurance_office_number: '',
            health_insurance_reason_exclusion: '',
          },
        };
        break;
    }
    return formValues;
  };

  /**
   * 年金保険加入状況（有、無、適用除外）により不必要な入力値をクリアする
   */
  clearPensionInsuranceState = (selectedInsuranceStatus, formValues) => {
    switch (selectedInsuranceStatus.key) {
      case EXCLUSION:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            pension_type_code: '',
            pension_type: '',
            pension_office_symbol: '',
            pension_office_number: '',
          },
        };
        break;
      case PRESENCE:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            pension_reason_exclusion: '',
          },
        };
        break;

      default:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            pension_type_code: '',
            pension_type: '',
            pension_office_symbol: '',
            pension_office_number: '',
            pension_reason_exclusion: '',
          },
        };
        break;
    }
    return formValues;
  };

  /**
   * 雇用保険加入状況（有、無、適用除外）により不必要な入力値をクリアする
   */
  clearEmploymentInsuranceState = (selectedInsuranceStatus, formValues) => {
    switch (selectedInsuranceStatus.key) {
      case EXCLUSION:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            employment_insurance_insurance_number: '',
          },
        };
        break;
      case PRESENCE:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            employment_insurance_reason_exclusion: '',
          },
        };
        break;
      default:
        formValues = {
          ...formValues,
          company_branch_insurance: {
            ...formValues.company_branch_insurance,
            employment_insurance_insurance_number: '',
            employment_insurance_reason_exclusion: '',
          },
        };
        break;
    }
    return formValues;
  };

  onCloseSafetyDocItemErrorDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.disabled.id,
    });
  };
  onOpenSafetyDocItemErrorDialog = () => {
    this.setState({
      dialogStatus: DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id,
    });
  };

  isUseSafety = () => {
    return this.state.use_greenfile_flg === 1;
  };

  /**
   * 安全書類項目に未入力がないかの確認
   * 安全書類項目は必須ではない
   */
  safetyDocItemValidate = () => {
    // 労務安全が使用できない場合は何もしない
    if (!this.isUseSafety()) {
      return {
        status: true,
      };
    }
    const safetyValues = this.getStateWithConvertedDate();

    safetyValues.building_name = this.state.formValues.building_name;

    const param = {
      constructionIndustryPermissionFlag:
        safetyValues.company_detail.construction_industry_permission_flag,
    };
    const result = validationByJoi(schemaForSafetyDoc(param), safetyValues);
    return result;
  };

  setSafetyDocErrorMessages = validateResult => {
    const errorMessages = createErrorMessageList(validateResult.messages);
    this.setState({
      confirmationModalSafetyDocItem: {
        errorPropertyList: errorMessages,
      },
    });
  };

  resetRequiredColumnWhenConstructionIndustryPermissionStatus = async () => {
    const { company_detail } = this.state.safetyValues;
    const isExistFlag = isConstructionIndustryPermissionStatus(
      company_detail.construction_industry_permission_flag
    );
    let columns = _.cloneDeep(this.state.requiredInput.columns);
    if (!_.includes(columns, 'construction_industry_permission_flag')) {
      columns = [...columns, 'construction_industry_permission_flag'];
    }
    if (!isExistFlag) {
      _.remove(columns, item => item === 'company_branch_permissions');
    } else {
      columns = _.union(columns, ['company_branch_permissions']);
    }
    this.setState(
      {
        requiredInput: {
          ...this.state.requiredInput,
          columns,
        },
      },
      () => {
        this.checkRequired();
      }
    );
  };

  //regional_development_bureau_idは""の場合、APIにnullを送る
  setEmptyRegionalDevelopmentBureauIdToNull = companyBranchPermissions => {
    const result = companyBranchPermissions.map(item => {
      if (showPrefectureInput(item.permitted_source_section)) {
        if (
          item.regional_development_bureau_id === '' ||
          item.regional_development_bureau_id === undefined ||
          !showRegionalDevelopmentBureau(item.prefectures_code_id)
        ) {
          item.regional_development_bureau_id = null;
        }
      } else {
        item.regional_development_bureau_id = null;
        item.prefectures_code_id = null;
      }
      return item;
    });
    return result;
  };

  handleCompanyBranchPermission = async (value, isCreate) => {
    const company_branch_permissions = _.cloneDeep(
      this.state.safetyValues.company_branch_permissions
    );
    if (isCreate) {
      company_branch_permissions.push(value);
    } else {
      _.forEach(company_branch_permissions, (item, index) => {
        if (_.get(item, 'id') === _.get(value, 'id')) {
          company_branch_permissions[index] = value;
          return false;
        }
      });
    }
    this.setState(
      {
        safetyValues: {
          ...this.state.safetyValues,
          company_branch_permissions,
        },
      },
      () => this.validate('company_detail')
    );
  };

  handleDeleteCompanyBranchPermission = (id, isCreate) => {
    let company_branch_permissions = _.cloneDeep(
      this.state.safetyValues.company_branch_permissions
    );
    let delete_company_branch_permission_group_ids = _.cloneDeep(
      this.state.safetyValues.delete_company_branch_permission_group_ids
    );
    const deletedCompanyBranchPermissionGroups = _.remove(
      company_branch_permissions,
      item => _.get(item, 'id') === id
    );
    let deletedCompanyBranchPermissionIds = [];
    if (!isCreate) {
      delete_company_branch_permission_group_ids = [
        ...delete_company_branch_permission_group_ids,
        id,
      ];
      deletedCompanyBranchPermissionIds = _.flatMap(
        deletedCompanyBranchPermissionGroups,
        'company_branch_permissions'
      )
        .filter(
          permission =>
            !!permission.id && permission._destroy !== EXISTANCE_FLAG.EXIST.ID
        )
        .map(permission => permission.id);
    }
    this.handleDeletePermissionExistGreenFile(
      deletedCompanyBranchPermissionIds,
      () =>
        this.setState(
          {
            safetyValues: {
              ...this.state.safetyValues,
              company_branch_permissions,
              delete_company_branch_permission_group_ids,
            },
          },
          () => this.validate('company_detail')
        )
    );
  };

  download = async fileId => {
    attachDocumentCompanyDownload(
      () => {
        this.setState({
          visibleDialogFlag: true,
        });
      },
      this.state.companyId,
      fileId
    );
  };

  closeError = () => {
    this.setState({
      visibleDialogFlag: false,
    });
  };

  handleValidateCompanyBranchPermission = () => {
    const { safetyValues } = this.state;
    const invalid = _.some(
      safetyValues.company_branch_permissions,
      'invalid_flag'
    );
    if (
      !isConstructionIndustryPermissionStatus(
        safetyValues.company_detail.construction_industry_permission_flag
      )
    ) {
      return true;
    }
    return !_.isEmpty(safetyValues.company_branch_permissions) && !invalid;
  };

  showErrorDialog = () => {
    dialogLoader.show(FormInformationDialog, {
      title: messageUtility.getMessage('E-001-402'),
      message:
        'エラーが発生しました。会社情報を開きなおし、再度操作を行ってください。',
      onClose: () => {
        dialogLoader.close();
        _masterSlideLoader.show('PrimeCompanyPreview', {
          state: {
            id: this.selectedCompanyId,
          },
        });
      },
    });
  };

  showUpdateErrorDialog = () => {
    dialogLoader.show(FormInformationDialog, {
      title: '更新に失敗しました',
      message: 'エラーが発生しました。再度操作を行ってください。',
      onClose: () => {
        dialogLoader.close();
        _masterSlideLoader.show('PrimeCompanyPreview', {
          state: {
            id: this.selectedCompanyId,
          },
        });
      },
    });
  };

  cleanupFormValuesBeforeUpdate = formValues => {
    const newFormValues = _.omit(formValues, [
      'company_branch_permissions',
      'delete_company_branch_permission_ids',
      'old_company_permission_documents',
    ]);
    newFormValues.company_branch_foreigner = _.omit(newFormValues.company_branch_foreigner, [
      'leader_name',
      'leader_position_name',
    ]);
    return newFormValues;
  };

  deleteOldCompanyPermissionDocuments = file => {
    attachDocumentDeleteState(
      this.state.safetyValues.old_company_permission_documents,
      documents => {
        this.setState(
          {
            safetyValues: {
              ...this.state.safetyValues,
              old_company_permission_documents: documents,
            },
          },
          () => {
            const deleteOldDocuments = _.cloneDeep(
              this.state.safetyValues
                .delete_company_branch_permission_document_ids
            );
            deleteOldDocuments.push(_.get(file, 'id'));
            this.setState({
              safetyValues: {
                ...this.state.safetyValues,
                delete_company_branch_permission_document_ids: deleteOldDocuments,
              },
            });
          }
        );
      },
      file
    );
  };

  render() {
    return (
      <React.Fragment>
        <div id='slide-view' className='contruction-slide-view show'>
          <Helmet>
            <title>{HEADER_CONSTANTS.title} - 会社情報</title>
          </Helmet>
          <div className='contruction-slide-view__view'>
            <MasterPageHeader
              title={'会社情報'}
              onClose={() => this.events.dialog.goBack()}
            />
            <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
              <div className='contruction-detail-view'>
                <div className='contruction-detail-view__sidemenu'>
                  <PrimaryCompanyNaviList
                    isSelectedHeadOfficeInformation={true}
                    isEditable={true}
                    expirationCompany={this.state.expirationCompany}
                  />
                </div>
                <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                  <div className='contruction-detail-view__menu'>
                    <span className='construction-detail-view__button'>
                      <button
                        className='btn--sub'
                        onClick={() => this.events.dialog.goBack()}
                      >
                        編集をやめる
                      </button>
                    </span>
                    <span className='construction-detail-view__button'>
                      <button
                        className={
                          _.size(this.state.validate.messages) !== 0 ||
                          this.state.validate.invalid
                            ? 'btn--effective btn--disabled'
                            : 'btn--effective'
                        }
                        onClick={() => {
                          if (!this.state.validate.invalid) {
                            this.events.form.update();
                          }
                        }}
                        disabled={this.state.validate.invalid}
                        data-testid={'register-btn'}
                      >
                        更新
                      </button>
                    </span>
                    <span
                      className='construction-detail-view__button'
                      style={{
                        right: '120px',
                        color: '#E64E17',
                        fontSize: '12px',
                      }}
                    >
                      {_.size(this.state.validate.messages) !== 0 ||
                      this.state.validate.invalid
                        ? '入力エラーがあります。'
                        : ''}
                    </span>
                    <div className='contruction-detail-view__end-item'>
                      {`必須項目の入力数 ${this.state.requiredInput.count}/${
                        this.state.requiredInput.total
                      }`}
                    </div>
                  </div>
                  <div className='contruction-detail-view__bar' />
                  <PrimeCompanyForm
                    roleId={this.state.roleId}
                    values={this.state.formValues}
                    events={this.events.form}
                    messages={this.state.validate.messages}
                    image={this.state.image.path}
                    use_greenfile_flg={this.state.use_greenfile_flg}
                    PrimeCompanySaftyForm={
                      <PrimeCompanySaftyForm
                        values={this.state.safetyValues}
                        messages={this.state.validate.messages}
                        checkboxList={this.state.checkboxList}
                        comboboxList={this.state.comboboxList}
                        events={this.events.form}
                        companyDocuments={this.state.companyDocuments}
                        documentCodes={this.state.documentCodes}
                        bureaux={this.state.bureaux}
                        eventCompanyBranchPermissionCommon={
                          this.eventCompanyBranchPermissionCommon
                        }
                        selectedCompanyId={this.state.companyId}
                      />
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 安全書類項目確認のダイアログ */}
        <ConfirmationSafetyDocItemDialog
          rootClassName={Style.safetyDocItemErrorDialog}
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.safetyDocItemErrorDialogEnabled.id
          }
          errorPropertyList={
            this.state.confirmationModalSafetyDocItem.errorPropertyList
          }
          onConfirm={() => {
            this.setState({ dialogStatus: DIALOG_STATUS.disabled.id }, () => {
              this.submit();
            });
          }}
          onCancel={this.onCloseSafetyDocItemErrorDialog}
        />
        <Information
          title={
            <div className='PartnerCompanyBranchSafetyPreview__infor'>
              <i className='icon-error' />
              <p>エラーが発生しました。</p>
            </div>
          }
          message='指定されたファイルが存在しません。'
          buttonText={messageUtility.getMessage('I-000-017')}
          visible={this.state.visibleDialogFlag}
          onClose={this.closeError}
          multilineText={true}
        />
        <DeleteCompanyLicenseConfirmDialog
          visible={this.state.visibleConfirmDeleteDialog}
          data={this.state.deleteCompanyBranchPermissionsExistGreenFile}
          bureaux={this.state.bureaux}
          onConfirm={this.confirmDeleteDialogFn}
          onCancel={() => this.setState({ visibleConfirmDeleteDialog: false })}
        />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PrimeCompanyEdit.jsx